"use client";
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    UserXSolid: function() {
        return UserXSolid;
    },
    default: function() {
        return _default;
    }
});
const _jsxruntime = require("react/jsx-runtime");
const _utils = require("@mui/material/utils");
const UserXSolid = (0, _utils.createSvgIcon)(/*#__PURE__*/ (0, _jsxruntime.jsxs)("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
        /*#__PURE__*/ (0, _jsxruntime.jsx)("path", {
            d: "M12 1C9.23858 1 7 3.23858 7 6C7 8.76142 9.23858 11 12 11C14.7614 11 17 8.76142 17 6C17 3.23858 14.7614 1 12 1Z",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, _jsxruntime.jsx)("path", {
            d: "M12 12C6.47715 12 2 16.4772 2 22C2 22.5523 2.44772 23 3 23H14.1708C13.7987 21.9447 14.0346 20.7228 14.8787 19.8787L15.2574 19.5L14.8787 19.1213C13.7071 17.9497 13.7071 16.0503 14.8787 14.8787C15.8609 13.8965 17.3547 13.7377 18.5023 14.4024C16.754 12.9047 14.4827 12 12 12Z",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, _jsxruntime.jsx)("path", {
            d: "M16.2929 17.7071C15.9024 17.3166 15.9024 16.6834 16.2929 16.2929C16.6834 15.9024 17.3166 15.9024 17.7071 16.2929L19.5 18.0858L21.2929 16.2929C21.6834 15.9024 22.3166 15.9024 22.7071 16.2929C23.0976 16.6834 23.0976 17.3166 22.7071 17.7071L20.9142 19.5L22.7071 21.2929C23.0976 21.6834 23.0976 22.3166 22.7071 22.7071C22.3166 23.0976 21.6834 23.0976 21.2929 22.7071L19.5 20.9142L17.7071 22.7071C17.3166 23.0976 16.6834 23.0976 16.2929 22.7071C15.9024 22.3166 15.9024 21.6834 16.2929 21.2929L18.0858 19.5L16.2929 17.7071Z",
            fill: "currentColor"
        })
    ]
}), "UserXSolid");
const _default = UserXSolid;
